import './App.css';
import './LandingPage'
import LandingPage from './LandingPage';



function App() {
  return (
    // <div className="App" style={{ backgroundImage: "url(/main-bg.jpeg)" }}>
    <div className="App">
     <LandingPage></LandingPage>
    </div>
  );
}

export default App;
